import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { isCatex, isSod, priceParser, isShowXxYPromotion, getItemSavingAmount } from '../../Helpers'
import TLBciPrice from './components/TLBciPrice'
import WlmPrice from './components/WlmPrice'
import Saving from './components/Saving'
import PricePerUm from './components/PricePerUm'
import RegularUnitPrice from './components/RegularUnitPrice'
import texts from '../../common/texts.json'
import SavingsLabel from '../SavingsLabel'
import SavingText from './components/SavingText'
import './index.css'

const ProductPrices = ({
  price,
  discount,
  price: { BasePricePerUm },
  tlBciImgClass,
  tlBciTextClass,
  wlmPriceTextClass,
  pricePerUmClass,
  regularUnitPriceLocation,
  enabledBciSod,
  enabledCatexXxYPack,
  soldByWeight,
}) => {
  const BasePriceSales = priceParser(price.BasePriceSales)
  const BasePriceReference = priceParser(price.BasePriceReference)
  const BasePriceTLMC = priceParser(price.BasePriceTLMC)
  const wlmPrice = BasePriceSales > 0 ? BasePriceSales : BasePriceReference

  const shouldDisplayText = (isCatex() || enabledBciSod) && (discount > 0 || BasePriceTLMC > 0)
  const shouldDisplayTLMC = (isCatex() || enabledBciSod) && BasePriceTLMC > 0
  const shouldDisplaySaving = BasePriceSales > 0 && BasePriceReference > BasePriceSales

  const shouldDisplayUm = isSod() && BasePricePerUm && BasePricePerUm !== '0' && soldByWeight && soldByWeight == 'true'

  const packPrice = Number(price.packPrice)
  const packSize = Number(price.packSize)
  const isXxYPromotion = isShowXxYPromotion(enabledCatexXxYPack, price)
  const productPrice = isXxYPromotion ? packPrice : wlmPrice
  const productPackQuantity = isXxYPromotion ? packSize : 0
  const showSodSavingsLabel = isSod() && discount > 0
  return (
    <div className="wlm-price">
      {shouldDisplayTLMC && <TLBciPrice price={BasePriceTLMC} imgClass={tlBciImgClass} textClass={tlBciTextClass} />}
      <WlmPrice
        price={productPrice}
        packQuantity={productPackQuantity}
        discount={discount}
        shouldDisplayText={shouldDisplayText}
        textClass={wlmPriceTextClass}
      >
        {showSodSavingsLabel && (
          <>
            <SavingsLabel savings={getItemSavingAmount(price)} classNames="ml-2" />
            <div className="wlm-price_flex-line-break" />
            <SavingText className={`ml-0 mt-0 mb-2`}>{texts.PRODUCT_PRICES.WLM_PRICE_TEXT}</SavingText>
          </>
        )}
      </WlmPrice>
      {isXxYPromotion && <RegularUnitPrice price={wlmPrice} location={regularUnitPriceLocation} />}
      {!isXxYPromotion && shouldDisplaySaving && (
        <Saving
          basePrice={BasePriceReference}
          saving={getItemSavingAmount(price)}
          showBeforePriceOnly={showSodSavingsLabel}
        />
      )}
      {shouldDisplayUm && <PricePerUm price={BasePricePerUm} priceClass={pricePerUmClass} />}
    </div>
  )
}

ProductPrices.propTypes = {
  price: PropTypes.object.isRequired,
  discount: PropTypes.number,
  tlBciImgClass: PropTypes.string,
  tlBciTextClass: PropTypes.string,
  wlmPriceTextClass: PropTypes.string,
  pricePerUmClass: PropTypes.string,
  regularUnitPriceLocation: PropTypes.string,
  enabledCatexXxYPack: PropTypes.bool,
  enabledBciSod: PropTypes.bool,
  soldByWeight: PropTypes.string,
}

ProductPrices.defaultProps = {
  discount: 0,
  tlBciImgClass: undefined,
  tlBciTextClass: undefined,
  wlmPriceTextClass: undefined,
  pricePerUmClass: undefined,
  regularUnitPriceLocation: undefined,
  enabledCatexXxYPack: false,
  enabledBciSod: false,
  soldByWeight: 'false',
}

export default ProductPrices
